import React from "react";
import { Link } from "react-router-dom";
import { ChevronLeft } from "lucide-react";

export default function TimerLapsePage() {
  return (
    <div className="px-5 sm:px-8 lg:px-12 py-16 sm:py-20 max-w-6xl mx-auto">
      <Link
        to="/"
        data-testid="timer-lapse-back-link"
        className="inline-flex items-center gap-2 text-[11px] tracking-[0.28em] uppercase text-white/40 hover:text-white/80 transition mb-10"
      >
        <ChevronLeft className="w-3.5 h-3.5" />
        Torna alla Home
      </Link>

      <div
        data-testid="timer-lapse-placeholder"
        className="grid md:grid-cols-[minmax(0,1fr)_minmax(0,1.2fr)] gap-10 lg:gap-14 items-start"
      >
        <div className="relative rounded-2xl overflow-hidden bg-white/[0.02] border border-white/5 shadow-[0_25px_80px_-20px_rgba(0,0,0,0.7)]">
          <img
            src="/images/timer-lapse.png"
            alt="Timer Lapse"
            data-testid="timer-lapse-image"
            className="w-full h-auto object-cover"
          />
        </div>

        <div>
          <div className="text-[11px] tracking-[0.32em] uppercase text-emerald-400/80 mb-4">
            In Primo Piano
          </div>
          <h1
            data-testid="timer-lapse-title"
            className="text-4xl sm:text-5xl font-extralight tracking-tight text-white leading-[1.05]"
          >
            Timer Lapse.
          </h1>
          <p className="mt-3 text-lg font-light text-white/60 leading-relaxed">
            Noi, in un lasso di tempo.
          </p>
          <p className="mt-6 text-white/70 font-light leading-relaxed max-w-xl">
            Il format live dell&apos;ecosistema TIME: momenti di condivisione in
            diretta per raccontare, insegnare e trasformare — nel breve arco
            di un lasso di tempo.
          </p>

          <div className="mt-10 glass-card p-8">
            <div className="text-[11px] tracking-[0.32em] uppercase text-emerald-400/70 mb-4">
              In arrivo
            </div>
            <p className="text-white/60 font-light leading-relaxed">
              Il calendario delle live, i temi e le modalità di partecipazione
              saranno disponibili a breve. Nel frattempo Timer Lapse è già
              parte dell&apos;esperienza TIME Inside.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
